import { render, staticRenderFns } from "./SelectMultiMunicipioSection.vue?vue&type=template&id=7227c960&scoped=true"
import script from "./SelectMultiMunicipioSection.vue?vue&type=script&lang=js"
export * from "./SelectMultiMunicipioSection.vue?vue&type=script&lang=js"
import style0 from "./SelectMultiMunicipioSection.vue?vue&type=style&index=0&id=7227c960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227c960",
  null
  
)

export default component.exports